import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { CartFacade } from '@boels/shared-state';
import {
  BOProduct,
  CartSuggestionsComponentData,
  CmsComponentData,
  ProductReference,
} from '@boels/models';
import { CarouselComponent } from '../product_image/carousel/carousel.component';
import { ProductCardComponent } from '../product-card/product-card.component';

import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'boels-cart-suggestions',
  templateUrl: './cart-suggestions.component.html',
  styleUrls: ['./cart-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarouselComponent, ProductCardComponent, AsyncPipe],
})
export class CartSuggestionsComponent implements OnInit {
  private cartFacade = inject(CartFacade);

  items$: Observable<Observable<BOProduct>[]>;
  title$: Observable<string>;
  productReferenceTypes$: Observable<string>;
  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;
  @Input() componentData: CmsComponentData<CartSuggestionsComponentData>;

  ngOnInit(): void {
    this.title$ = this.componentData$.pipe(map((data) => data?.title));
    this.productReferenceTypes$ = this.componentData$.pipe(
      map((data) => data?.productReferenceTypes),
    );
    this.updateProductReferences();
  }

  private updateProductReferences(): void {
    this.items$ = this.getProductReferences();
  }

  private getProductReferences(): Observable<Observable<BOProduct>[]> {
    return this.productReferenceTypes$.pipe(
      map((types) => types.split(' ').join(',')),
      switchMap((types) => this.cartFacade.getActiveCartReferences(types)),
      map((references: ProductReference[]) =>
        references.map((reference) => of(reference.target as BOProduct)),
      ),
    );
  }

  protected get componentData$(): Observable<CartSuggestionsComponentData> {
    return this.componentData.data$.pipe(
      filter(Boolean),
      map((unk) => unk as CartSuggestionsComponentData),
    );
  }
}
